import md5 from 'blueimp-md5';

/**
 * Calculates MD5 value for a given string.
 *
 * @param {string} string Input string
 * @returns {string} MD5 output
 */
function funcMd5(str: string): string {
  return str ? md5(str) : '';
}

export default funcMd5;
